import React from 'react';
import { IconProps } from './IconProps';

export const SearchIcon = ({ scale = 1, fill = '#e4e6e8' }: IconProps): JSX.Element => {
    return (
        <>
            <svg
                width={scale * 24}
                height={scale * 24}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M23.4985 23.5056C23.1627 23.823 22.7175 24 22.2546 24C21.7917 24 21.3464 23.823 21.0107 23.5056L14.6436 17.1926C13.0706 18.2054 11.2397 18.7488 9.36686 18.7589C7.50682 18.7494 5.69128 18.1912 4.14934 17.1549C2.60739 16.1185 1.40814 14.6503 0.702927 12.9356C-0.00229263 11.2209 -0.181881 9.33655 0.186825 7.52028C0.555531 5.70401 1.45601 4.03723 2.77462 2.73029C4.09324 1.42334 5.7709 0.534784 7.59592 0.176748C9.42093 -0.181288 11.3115 0.00723983 13.0291 0.718541C14.7466 1.42984 16.2142 2.63204 17.2467 4.17343C18.2791 5.71483 18.8301 7.52634 18.8301 9.37938C18.8428 11.2972 18.2484 13.1702 17.1314 14.7322L23.4985 21.0452C23.8201 21.3746 24 21.816 24 22.2754C24 22.7349 23.8201 23.1763 23.4985 23.5056ZM9.36686 16.3525C10.7616 16.3454 12.123 15.9269 13.2792 15.1497C14.4354 14.3726 15.3346 13.2717 15.8634 11.986C16.3922 10.7002 16.5269 9.28725 16.2504 7.92534C15.9739 6.56342 15.2987 5.31361 14.31 4.33361C13.3212 3.35361 12.0632 2.68734 10.6948 2.41887C9.32631 2.1504 7.90868 2.29176 6.62078 2.82513C5.33287 3.35849 4.23241 4.25995 3.45826 5.41574C2.68411 6.57154 2.27096 7.92989 2.27094 9.31937C2.26933 10.2465 2.45203 11.1647 2.80851 12.0211C3.16499 12.8774 3.68819 13.655 4.3479 14.3089C5.00762 14.9628 5.79079 15.48 6.65222 15.8307C7.51365 16.1815 8.43628 16.3588 9.36686 16.3525Z"
                    fill={fill}
                    style={{ transition: 'fill .2s linear' }}
                />
            </svg>
        </>
    );
};
